import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function Hero({ title, subtitle, ctaText, ctaLink, image }) {
  return (
    <section className="relative bg-white pt-20 lg:pt-0 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center min-h-[85vh]">
          
          {/* Text Content - Left Side */}
          <div className="w-full lg:w-1/2 pt-12 pb-16 lg:py-24 lg:pr-12 relative z-10">
            <div className="max-w-2xl">
              {/* Subtle accent badge */}
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#d3b39f]/10 border border-[#d3b39f]/20 rounded-full mb-8">
                <span className="w-2 h-2 rounded-full bg-[#876a57] animate-pulse"></span>
                <span className="text-xs font-semibold uppercase tracking-widest text-[#876a57]">Professionel Rådgivning</span>
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-slate-900 leading-[1.1] mb-8">
                {title.split(' ').map((word, i) => (
                  <span key={i} className={i === 0 ? "text-[#876a57]" : ""}>
                    {word}{' '}
                  </span>
                ))}
              </h1>
              
              <p className="text-lg md:text-xl text-slate-600 mb-10 max-w-xl leading-relaxed">
                {subtitle}
              </p>
              
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <Link 
                  to={ctaLink} 
                  className="group relative inline-flex items-center justify-center px-8 py-4 bg-[#876a57] text-white font-bold rounded-sm transition-all duration-300 hover:shadow-xl hover:shadow-[#876a57]/20 hover:-translate-y-0.5 overflow-hidden"
                >
                  <span className="relative z-10 flex items-center gap-2">
                    {ctaText}
                    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </Link>
              </div>
            </div>
          </div>

          {/* Visual Side - Right Side */}
          <div className="w-full lg:w-1/2 relative h-[400px] lg:h-[85vh]">
            {/* Background decorative shape */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-slate-50 rounded-full blur-3xl -z-10 opacity-60"></div>
            
            <div className="relative h-full w-full lg:pl-12 py-12 lg:py-24">
              {/* Main Image Container with offset borders */}
              <div className="relative h-full w-full group">
                {/* Decorative frames */}
                <div className="absolute -top-4 -left-4 w-24 h-24 border-t-4 border-l-4 border-[#d3b39f] z-20"></div>
                <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-4 border-r-4 border-[#876a57] z-20"></div>
                
                {/* Image */}
                <div className="relative h-full w-full overflow-hidden shadow-2xl">
                  <img 
                    src={image} 
                    alt="Professional Workspace" 
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  {/* Subtle Overlay */}
                  <div className="absolute inset-0 bg-[#876a57]/5 mix-blend-multiply transition-opacity duration-300 group-hover:opacity-0"></div>
                </div>

                {/* Floating Info Card */}
                <div className="absolute bottom-12 -left-6 lg:-left-12 bg-white p-6 shadow-xl hidden sm:block z-30 max-w-xs border-l-4 border-[#876a57]">
                  <p className="text-sm font-medium text-slate-500 uppercase tracking-wider mb-2">Vores Mission</p>
                  <p className="text-lg font-bold text-slate-900 leading-snug">
                    Vi skaber værdi gennem strategisk overblik og eksekvering.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}
